import { createFeatureSelector } from '@ngrx/store';

export const availablePickupsState = createFeatureSelector<OLO.State, OLO.State.AvailablePickup[]>('availablePickups');
